import { render, staticRenderFns } from "./ReusableWizard.vue?vue&type=template&id=6ad44d3f"
import script from "./ReusableWizard.vue?vue&type=script&lang=js"
export * from "./ReusableWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ad44d3f')) {
      api.createRecord('6ad44d3f', component.options)
    } else {
      api.reload('6ad44d3f', component.options)
    }
    module.hot.accept("./ReusableWizard.vue?vue&type=template&id=6ad44d3f", function () {
      api.rerender('6ad44d3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/wizard/ReusableWizard.vue"
export default component.exports